import Icon from '../../components/Icon.vue'

Icon.register({"brands/maxcdn":{"width":512,"height":512,"paths":[{"d":"M461.1 442.7H363.7L415.6 200C417.9 189.8 416.5 180.5 411.2 174.3 406.2 168.2 397.5 164.7 387 164.7H337.7L278.2 442.7H180.8L240.3 164.7H156.9L97.4 442.7H0L59.5 164.7 14.9 69.3H387C426.4 69.3 462.3 85.6 485.3 114.2 508.6 142.8 517.1 181.6 508.9 220.1L461.1 442.7z"}]}})



//////////////////
// WEBPACK FOOTER
// ./node_modules/_vue-awesome@3.0.0@vue-awesome/icons/brands/maxcdn.js
// module id = null
// module chunks = 